// Module
var code = "<div loading=\"isLoading\" backdrop=\"true\" note=\"One moment, we are securely connecting you to Collective Health.\"></div> ";
// Exports
var _module_exports = code;;
var path = '@collectivehealth/frontend-member-v2/pages/sso/sso.html';
var angular = require('angular');
angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;